import {PessoaFisicaSisbi} from './pessoa-fisica-sisbi';
import {PessoaJuridicaSisbi} from './pessoa-juridica-sisbi';

export class PessoaSisbi {
    cdTipoPessoa: string;
    dtRegistro: string;
    idPessoa: number;
    pessoaFisica: PessoaFisicaSisbi;
    pessoaJuridica: PessoaJuridicaSisbi;

    get isPessoaJuridica(): boolean {
        return this.cdTipoPessoa === 'J' && this.pessoaJuridica != null;
    }

    get isPessoaFisica(): boolean {
        return this.cdTipoPessoa === 'F' && this.pessoaFisica != null;
    }

    get nome(): string {
        if (this.isPessoaFisica) {
            return this.pessoaFisica.nmPessoaFisica;
        } else if (this.isPessoaJuridica) {
            return this.pessoaJuridica.nmRazaoSocial;
        }
        return '';
    }
    get cpfOrCnpj(): string {
        if (this.isPessoaJuridica) {
            return this.pessoaJuridica.nrCnpj;
        }
        if (this.isPessoaFisica) {
            return this.pessoaFisica.nrCpf;
        }
        return '';
    }

    /**
     * Converte um objeto json em instancias da classe
     */
    static fromJson(jsonData: any): PessoaSisbi {
        if (jsonData.pessoaFisica != null) {
            jsonData.pessoaFisica = PessoaFisicaSisbi.fromJson(jsonData.pessoaFisica);
        }
        if (jsonData.pessoaJuridica != null) {
            jsonData.pessoaJuridica = PessoaJuridicaSisbi.fromJson(jsonData.pessoaJuridica);
        }
        return Object.assign(new PessoaSisbi(), jsonData);
    }
}
